// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Error_button__2oR71 {\n  cursor: pointer;\n  margin-top: 15px;\n  text-align: center;\n  color: var(--color-bar);\n  text-decoration: underline;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Navigation/Error.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;AAC5B","sourcesContent":[".button {\n  cursor: pointer;\n  margin-top: 15px;\n  text-align: center;\n  color: var(--color-bar);\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "Error_button__2oR71"
};
export default ___CSS_LOADER_EXPORT___;
